import styled, { css } from "styled-components";
import { theme } from "styles/mui-config";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";

const activeDrawerLink = ({ $isActive }) => {
  if ($isActive) {
    return css`
      background-color: ${theme.palette.primary.dark} !important;
      & > a {
        color: white !important;
      }
      & > a > div > svg {
        color: white !important;
      }
      & > a > div > span > svg {
        color: white !important;
      }
    `;
  }
};

export const StyledListItemText = styled(ListItemText)`
  & > span {
    font-size: 16px;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  ${activeDrawerLink},
  & > a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: inherit;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 95% !important;
    margin: auto !important;
    border-radius: 4px !important;
    padding-right: 4px !important;
  }
  :hover {
    background-color: ${theme.palette.primary.dark};
  }
`;

export const StyledPaper = styled(Paper)`
  position: sticky;
  top: 20px;
  margin-bottom: 80px;
  @media (max-width: 900px) {
    position: static;
    top: 0;
    margin-bottom: 20px;
  }
`;
